import { getData, postData } from "@/utils/http";
import config from "@/config"
import moment from "moment";
import Big from "big-js";
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],
		name: "",
		pageIndex: 1,
		total: 0,
		activeTab: 'inner',
		deptId: "",
		timerArray: [moment().format("yyyy-MM-DD"), moment().format("yyyy-MM-DD")],

	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading;
		},
		CHANGE_ADD_LOADING(state, addLoading) {
			state.addLoading = addLoading;
		},
		CHANGE_TABLE_DATA(state, changeData) {
			state.tableList = changeData.data.rows;
			state.total = changeData.total;
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item;
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData["changeKey"] == "orgId" && typeof changeData["data"] != "object") {
				state[changeData["changeKey"]] = [changeData["data"]];
			} else {
				state[changeData["changeKey"]] = changeData["data"];
			}
		},
		CHANGE_TABLE_INDEX(state, value) {
			state.pageIndex = value;
		}
	},
	actions: {
		//获取列表
		getList({ commit, state }, deptId) {
			return new Promise((resolve) => {
				var start = "";
				var end = "";
				if (state.timerArray && state.timerArray.length > 0) {
					start = state.timerArray[0];
					end = state.timerArray[1];
				}
				getData(`logistics/operation/driver/time/list/v2?name=${state.name}&page=${state.pageIndex}&size=${config.pageSize}&deptId=${deptId}&end=${end}&start=${start}`).then((res) => {
					if (res.state == 1) {
						//对分时数据进行补齐
						var dataRows = res.data.rows;
						
						var rowsKey = "";
						var planRowskey = "";
						for (var i = 0; i < res.data.rows.length; i++) {
							var actualData = {};
							var planData = {};
							for (var j = 0; j < res.data.rows[i]['actual'].length; j++) {
								rowsKey = Object.keys(res.data.rows[i]['actual'][j]);

								actualData[rowsKey] = res.data.rows[i]['actual'][j][rowsKey];
							}

							for (var j = 0; j < res.data.rows[i]['plan'].length; j++) {
								planRowskey = Object.keys(res.data.rows[i]['plan'][j]);
								planData[planRowskey] = res.data.rows[i]['plan'][j][planRowskey];
							}



							dataRows[i]['actual'] = actualData;
							dataRows[i]['plan'] = planData;
						}

						var start = "";
						var end = "";
						var staticDataRows = dataRows;
						dataRows.forEach((item, index) => {
							var allActual = Object.keys(item['actual']);
							var allPlan = Object.keys(item['plan']);
							allActual.forEach((actualItem, actualIndex) => {
								if (allActual[actualIndex + 1]) {
									start = actualItem;
									end = allActual[actualIndex + 1];
									var timeDiff = new Big(moment(end, "YYYYMMDDHHmm").diff(moment(start, "YYYYMMDDHHmm"), 'minutes')).valueOf(0);
									for (var i = 1; i < timeDiff; i++) {
										if (item['actual'][`${start}`] == 5 || item['actual'][`${start}`] == 6) {
											staticDataRows[index]['actual'][`${moment(start, "YYYYMMDDHHmm").add(i, 'minutes').format('YYYYMMDDHHmm')}`] = 999;
										} else {
											staticDataRows[index]['actual'][`${moment(start, "YYYYMMDDHHmm").add(i, 'minutes').format('YYYYMMDDHHmm')}`] = 1;
										}
									}
								}
							});
							allPlan.forEach((planItem, planIndex) => {
								if (allPlan[planIndex + 1]) {
									start = planItem;
									end = allPlan[planIndex + 1];
									var timeDiff = new Big(moment(end, "YYYYMMDDHHmm").diff(moment(start, "YYYYMMDDHHmm"), 'minutes')).valueOf(0);
									for (var i = 1; i < timeDiff; i++) {
										if (item['plan'][`${start}`] == 5 || item['plan'][`${start}`] == 6) {
											staticDataRows[index]['plan'][`${moment(start, "YYYYMMDDHHmm").add(i, 'minutes').format('YYYYMMDDHHmm')}`] = 999;
										} else {
											staticDataRows[index]['plan'][`${moment(start, "YYYYMMDDHHmm").add(i, 'minutes').format('YYYYMMDDHHmm')}`] = 1;
										}
									}
								}
							});
						});
						commit("CHANGE_TABLE_DATA", {
							data: {
								rows: staticDataRows
							},
							total: res.data.total
						});
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						commit("CHANGE_TABLE_DATA", {
							data: {
								rows: [],
								total: 0
							}
						});
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},
		//获取车辆类型
		getCarTypeList({ commit, state }) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dict/data/type/car_type`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},

		//写入当前操作条目
		setActiveItem({ commit }, item) {
			commit("CHANGE_ACTIVE_ITEM", item)
		},

		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit("CHANGE_SEARCH_COLL", changeData)
		},
		//修改分页
		setPageIndex({ commit }, value) {
			commit("CHANGE_TABLE_INDEX", value)
		},
		//修改添加loading
		changeAddLoading({ commit }, value) {
			commit("CHANGE_ADD_LOADING", value)
		},
		//修改添加loading
		changeListLoading({ commit }, value) {
			commit("CHANGE_TABLE_LOADING", value)
		}
	}
}
